import gql from 'graphql-tag';
import { schema as orderSummarySchema } from '../../queries/getOrderSummary';

export default gql`
mutation removePromoCode($code: String!){
    removePromoCode(code: $code) { ${orderSummarySchema} }
}`;
